import { Injectable } from '@angular/core';

@Injectable()
export class JwtService {
  getToken(): String {
    return window.localStorage['token'];
  }
  getAuthToken(): String {
    let token = null;
    let credentials = window.localStorage['credentials'];
    if (credentials != undefined) {
      token = JSON.parse(credentials).token;
    }
    return token;
  }
  // saveCurrentUserID(UID: string) {
  //   window.localStorage['UID'] = UID;
  // }
  // getCurrentUserID() {
  //   return window.localStorage.getItem('UID');
  // }
  // getParticipantId(): String {
  //   let participant_id = window.localStorage.getItem('participant_id')
  //   return participant_id;
  // }
  // saveParticipantId(participantID: string) {
  //  window.localStorage['participant_id'] = participantID;
  // }
  getIdentity(): any {
    let identity_vo = window.localStorage.getItem('identity')
    return identity_vo;
  }

  getLoggedInUser(): any {
    let user = window.localStorage.getItem('credentials')
    return JSON.parse(user);
  }
  isLoginSuccess(): boolean {
    var isSuccess = false;
    if (window.localStorage.getItem('isSuccess') == 'true') {
      isSuccess = true;
    }
    return isSuccess;
  }
  setLoginSuccess(isSuccess: string) {
    window.localStorage['isSuccess'] = isSuccess;
  }
  saveUserDetails(userData: any) {
    window.localStorage['userData'] = userData;
  }
  getUserDetails(): any {
    let userDetails = window.localStorage['userData'];
    return JSON.parse(userDetails);
  }
  destroyUserDetails() {
    window.localStorage.removeItem('userData');
  }
  saveIdentity(identityVO: any) {
    window.localStorage['identity'] = identityVO;
  }
  saveUserRole(role: string) {
    window.localStorage['role'] = role;
  }
  getUserRole(): string {
    return window.localStorage['role'];
  }
  destroyParticipantId() {
    window.localStorage.removeItem('participant_id');
  }
  saveToken(token: String) {
    window.localStorage['token'] = token;
  }
  // saveTokenWithUserData(token: any) {
  //   localStorage.setItem('TokenWithUserData', JSON.stringify(token));
  // }
  destroyToken() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('isSuccess');
  }
}
